<template>
  <div class="page-content">
    <div class="headings">
      <h2 class="title title-primary">{{ location }}</h2>
      <span>|</span>
      <h2 class="title title-primary">
        {{ $t("lang.common.sale_return") }}
      </h2>
    </div>
    <div class="page-header">
      <div class="boxes" v-if="!shouldLoading">

        <bx-box dark color="outline" class="col-4 col-lg-auto p-1">
          <bx-value
            :label="$t('lang.common.sale_return')"
            :value="ordersCount"
            font-size="xs"
            valueColor="red"
          />
        </bx-box>
      </div>
      <skeleton-boxes progress-box :boxes="5" v-else />
    </div>
    <div class="page-main-content">
      <div class="container-fluid"><v-row class="justify-content-end pt-5 pb-0">
        </v-row>
        <div class="row">
          <bx-box :title="ordersCount + ' ' + $t('lang.inbound.dashboard.table_title')" color="white" class="col-12 pt-0 mt-0" no-padding 
          :loading="shouldLoading">
            <template v-slot:default>
              <bx-table
                :data="data"
                :columns="columns"
                paginated
                backendPagination
                :currentPage="page"
                :perPage="itemsPerPage"
                :total="ordersCount"
                v-if="!shouldLoading"
                @search="onSearch"
                @update:currentPage="updatePage"
              >
                <template slot-scope="props">
                  <bx-table-column centered>
                    <router-link :to="`/outbound/returns/${props.row.id}/detail`" 
                    class="bx-link bx-link-bold">{{ props.row.id }}
                    </router-link>
                  </bx-table-column>
                  <bx-table-column centered>{{props.row.code}}</bx-table-column>
                  <bx-table-column centered>{{formatDate(props.row.arrival_date)}}</bx-table-column>
                  <bx-table-column centered>{{props.row.real_item_count}}</bx-table-column>
                </template>
              </bx-table>
            </template>
          </bx-box>
        </div>
        <skeleton-table :columns="10" v-if="shouldLoading" />
      </div>
    </div>
  </div>
</template>

<script>
import BxTableColumn from "../../../bx-components/BxTableColumn";
import moment from "moment/dist/moment";
import common from "@/utils/common";
// import Download from '@/components/Download.vue'

var loading = false;
export default {
  name: "sale-return-dashboard",
  mixins: [common],
  components: { BxTableColumn },
  data() {
    return {
      key: "outbound",
      selectedRows: [],
      selectedRecords: [],
      clean_array: [],
      shouldLoading: true,
      columns: [],
      dialog: false,
      data: [],
      dataList: [],
      ordersCount: "",
      receptionTime: "",
      maxReceptionTime: "",
      delayAvgReceptionTime: "",
      orderPerDay: "",
      orderIncorrectPerDay: "",
      inboundData: {},
      outboundData: {},
      evolutionData: {},
      stock: {},
      API_BASE: process.env.VUE_APP_API_BASE,
      reloadInterval: null,
      locationId: null,
      itemsPerPage: process.env.VUE_APP_ITEMS_PER_PAGE,
      page: 1,
      filters: {
        origin__name__contains: null,
        arrival_date__contains: null,
        arrival_date__gte: null,
        arrival_date__lte: null,
      },
    };
  },
  computed: {
    role: function () {
      return this.$store.state.user.role;
    },
    location() {
      return localStorage.getItem("location");
    },
  },
  methods: {
    loadMore() {
      if (
        !this.shouldLoading &&
        this.dataList.length &&
        this.dataList.length < this.ordersCount &&
        this.isMobile
      ) {
        this.page++;
        this.getData();
      }
    },
    formatDate(date) {
      return date
        ? moment(date).format("DD/ MM/ YYYY, h:mm a")
        : this.$t("lang.messages.no_date_available");
    },
    onSearch(field, value) {
      this.$session.set(this.key + field, value);
      switch (field) {
        case "id":
          this.filters.orderCode = value;
          this.getData();
          break;
        case "origin":
          this.filters.origin = value;
          this.getData();
          break;
        case "arrivalDate":
          this.filters.arrivalDate = value;
          this.getData();
          break;
      }
    },

    updatePage(p) {
      // window.location.href = '/outbound'
      this.page = p;
      this.getData();
    },

    async getOrders(locationId) {
      try {
        if (this.isMobile) {
          this.shouldLoading = true;
        }
        // Load orders
        const orders = await this.$api.orders.list_sale_returns(locationId, {
          offset: (this.page - 1) * this.itemsPerPage,
          limit: this.itemsPerPage,
          code__contains: this.filters.orderCode,
          arrival_date__gte:
            this.filters.arrivalDate && this.filters.arrivalDate.date_start,
          arrival_date__lte:
            this.filters.arrivalDate && this.filters.arrivalDate.date_end,
          }
        );

        this.ordersCount = orders.count;
        let data = (this.data = orders.results.map(item => {
          let isAfter = moment().isAfter(item.estimated_arrival_date);
          let tmp_provider = null;
          let tmp_provider_id = null;
          if (item.provider != null) {
            tmp_provider = item.provider.name;
            tmp_provider_id = item.provider.id;
          }
          let order_code = null;
          if (item.order != null) {
            order_code = item.order.order_code;
          }
          return {
            id: item.id,
            real_item_count: item.real_item_count,
            arrival_date: item.end_time,
            code: item.code,
            time_color: isAfter ? "bx-text-red" : "bx-text-black"
          };
        }));

        if (this.isMobile) {
          this.dataList = this.dataList.concat(data);
        }

        this.columns = [
          {
            field: "id",
            label: this.$t("lang.inbound.dashboard.table_id"),
            centered: true
          },
          {
            field: "code",
            label: this.$t("lang.inbound.dashboard.table_field_3"),
            filter: {
              placeholder: this.$t(
                "lang.inbound.dashboard.table_field_placeholder_5"
              ),
              value: this.filters.orderCode
            },
            centered: true
          },
          {
            field: "arrivalDate",
            label: this.$t("lang.inbound.dashboard.table_field_4"),
            filter: {
              placeholder: this.$t(
                "lang.inbound.dashboard.table_field_placeholder_4"
              ),
              value: this.filters.arrivalDate,
              isdateRange: true
            },
            centered: true
          },
          {
            field: "real_item_count",
            label: this.$t("lang.inbound.dashboard.table_field_6"),
            centered: true
          }
        ];
      } catch (error) {
        console.log(error);
      } finally {
        this.selectedRecords = [];
        this.selectedRows = [];
      }
    },
    async getData() {
      try {
        // Load stats
        if (!loading) {
          loading = true;
          let location = localStorage.getItem("location");
          this.locationId = localStorage.getItem("location_id");
          if (!location) {
            try {
              let firstLocation = await this.$api.location.search("", {
                limit: 1,
                offset: 0,
                orderBy: "id"
              });
              location = firstLocation.results[0].description;
              this.locationId = firstLocation.results[0].id;
            } catch (error) {
              console.log(error);
            }
          }

          // Load orders
          await this.getOrders(this.locationId);

          loading = false;
          this.shouldLoading = false;
          this.selectedRecords = [];
          this.selectedRows = [];
        }
      } catch (error) {
        // console.log(error)
      }
    },
    formattedDate(date) {
      return date ? moment(date.toString()).format("YYYY-MM-DD") : "";
    },
    async download() {
      const fromDate =
        this.filters.arrivalDate &&
        this.formattedDate(this.filters.arrivalDate.date_start) + " 00:00:00";
      const toDate =
        this.filters.arrivalDate &&
        this.formattedDate(this.filters.arrivalDate.date_end) + " 23:59:59";
      const locationId = this.locationId;
      await this.$api.printer.downloadPrinter(locationId, fromDate, toDate);
    }
  },
  mounted() {
    this.filters.orderCode = this.$session.get(this.key + "id");
    this.filters.origin = this.$session.get(this.key + "origin");
    this.filters.arrivalDate = this.$session.get(this.key + "arrivalDate");
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.reloadInterval);
  }
};
</script>

<style scoped>
@media screen and (max-width: 578px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 10px;
  }
}
</style>

<style scoped>
@media screen and (max-width: 414px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 89px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 0px !important;
  }
}

@media screen and (max-width: 411px) {
  .bx-box-adjustable >>> .bx-box-content {
    min-height: 79px;
  }

  .bx-box-adjustable >>> .bx-value-value {
    margin-top: 0px !important;
  }
}
</style>
